import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StackedMove"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 5.25L17.6925 6.3075L19.5 8.25H15.75V5.25C15.75 4.42157 15.0784 3.75 14.25 3.75H6.75V5.25H14.25V15.75H15.75V9.75H19.5L17.6925 11.6925L18.75 12.75L22.5 9L18.75 5.25ZM11.25 21H3C2.17157 21 1.5 20.3284 1.5 19.5V8.25C1.5 7.42157 2.17157 6.75 3 6.75H11.25C12.0784 6.75 12.75 7.42157 12.75 8.25V19.5C12.75 20.3284 12.0784 21 11.25 21ZM3 19.5V8.25H11.25V19.5H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StackedMove.vue"]]);
